module.exports = __webpack_public_path__ + "static/img/jigou-qingdao-bottom.04dbfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-qingdao-bottom.png
// module id = zC3R
// module chunks = 2